var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faqElement"},[_c('div',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))]),_vm._v(" "),_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.answer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }